import { type ColumnLoader, tableCellLoaderWidth } from '@/core/tables/types'

export const SYM_TABLE_ROW_HOVERED = Symbol('TableRowHovered')
export const TM_CHECKBOX_LOADER_CLASS = 'tm-checkbox' as const
export const defaultLoaderColumnConfig: Array<ColumnLoader> = [
  { loaderWidth: tableCellLoaderWidth.checkbox, loaderType: 'rect', loaderClass: TM_CHECKBOX_LOADER_CLASS },
  { loaderWidth: 100, dynamicLoaderWidth: true, loaderType: 'chip' },
  { loaderWidth: 150, dynamicLoaderWidth: true, loaderType: 'chip' },
  { loaderWidth: 100, dynamicLoaderWidth: true, loaderType: 'chip' },
  { loaderWidth: 100, dynamicLoaderWidth: true, loaderType: 'chip' },
  { loaderWidth: 16, loaderType: 'circle', loaderClass: 'td-actions' },
]
